import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api, formatApiError } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Mail, CheckCircle2, ArrowLeft } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      await api.post('/auth/password/forgot', { email });
      setSent(true);
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] max-w-md mx-auto px-6 lg:px-10 py-20">
      <Link to="/login" className="text-sm text-muted-foreground link-underline inline-flex items-center gap-1 mb-8">
        <ArrowLeft size={14}/> Torna al login
      </Link>
      {sent ? (
        <div data-testid="forgot-sent" className="rounded-2xl border border-chartreuse/40 bg-chartreuse/5 p-8 text-center">
          <div className="w-14 h-14 mx-auto rounded-full bg-chartreuse text-obsidian grid place-items-center mb-4">
            <CheckCircle2 size={26}/>
          </div>
          <h2 className="font-display text-2xl mb-3">Controlla la tua email</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Se <b>{email}</b> è registrata su AgriNexus, riceverai un link per reimpostare la password entro pochi minuti.
          </p>
          <p className="text-xs text-muted-foreground mt-4">
            Il link scade in 30 minuti. Controlla anche la cartella spam.
          </p>
          <Link to="/login">
            <Button variant="outline" className="rounded-full mt-6">Torna al login</Button>
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} data-testid="forgot-form" className="rounded-2xl border border-border p-8 md:p-10 bg-card space-y-5">
          <div className="w-12 h-12 rounded-xl bg-foreground text-background grid place-items-center">
            <Mail size={20}/>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-terracotta mb-2">Reset password</div>
            <h1 className="font-display text-3xl tracking-tight">Ti mandiamo un link</h1>
            <p className="mt-3 text-sm text-muted-foreground">Inserisci l'email del tuo account: ti invieremo un link sicuro per scegliere una nuova password.</p>
          </div>
          <div className="space-y-2">
            <Label>Email</Label>
            <Input type="email" value={email} onChange={e=>setEmail(e.target.value)} required autoFocus data-testid="forgot-email"/>
          </div>
          {err && <div className="text-sm text-destructive">{err}</div>}
          <Button type="submit" disabled={busy} data-testid="forgot-submit" className="w-full rounded-full h-11">
            {busy ? 'Invio in corso…' : 'Invia link di reset'}
          </Button>
        </form>
      )}
    </div>
  );
}
